import { DollarIcon } from '@synoptic/ui-kit/icons/react/dollar.tsx';
import { clsx } from 'clsx';
import { ComponentPropsWithoutRef, FC } from 'react';
import { streamPriceTag } from '@/components/streams/stream-tag/stream-price-tag.css.ts';
import { StreamTag } from '@/components/streams/stream-tag/stream-tag.tsx';

export const StreamPriceTag: FC<
  {
    price?: number;
    packageOnly?: boolean | null;
    outlined?: boolean;
  } & ComponentPropsWithoutRef<'div'>
> = ({ price, packageOnly, outlined, className, ...props }) => (
  <StreamTag
    icon={price && <DollarIcon />}
    className={clsx(streamPriceTag, className)}
    data-outlined={outlined ? '' : undefined}
    {...props}
  >
    {price ? `${price} / month` : packageOnly ? 'In-package' : 'Free'}
  </StreamTag>
);
